import { render, staticRenderFns } from "./CreateConversation.vue?vue&type=template&id=70d950dc"
import script from "./CreateConversation.vue?vue&type=script&lang=js"
export * from "./CreateConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports